<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2023-01-10 10:58:12
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-10 18:01:48
-->
<template>
  <x-dialog
    :title="importTitle ? importTitle : '导入'"
    :show.sync="visible"
    v-if="visible"
    :before-close="handleClose"
    width="40%"
  >
    <el-upload
      ref="upload"
      :action="uploadUrl"
      :auto-upload="false"
      :before-upload="handleBeforeUpload"
      :data="improtData"
      :file-list="fileList"
      :headers="headers"
      :limit="limit"
      :on-change="onchange"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :show-file-list="false"
      class="upload-demo"
      drag
      multiple
    >
      <!-- <el-alert
        v-show="temo"
        title="从菜单列表选择一项后，进行编辑"
        type="info"
        show-icon
        style="margin-bottom: 10px"
      ></el-alert> -->
      <el-button><i class="el-icon-upload2"></i>上传</el-button>
      <div v-if="showTip" slot="tip" class="el-upload__tip">
        <b style="color: #f56c6c">{{ showTip }}</b>
      </div>
    </el-upload>
  </x-dialog>
</template>

<script>
  import { Http } from '@main/common/api'
  // import { TokenService } from '@package/service'
  export default {
    name: 'CommonImportant',
    props: {
      importUrl: {
        type: String,
        default: ''
      },
      showTip: {
        type: String,
        default: ''
      },
      importTitle: {
        type: String,
        default: ''
      },
      improtData: {
        // 上传时附带的额外参数
        type: Object,
        default: () => {}
      },
      limit: {
        type: Number,
        default: 1
      },
      // 大小限制(MB)
      fileSize: {
        type: Number,
        default: 30
      },
      fileType: {
        type: Array,
        default: () => []
      },
      templateCode: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        loading: false,
        fileUrl: '',
        fileName: '',
        templateName: '',
        headers: {
          Authorization: 'Bearer '
        },
        templatUrl: '/upms/template/findById/',
        fileList: [],
        uploadFiles: [],
        uploadFlag: false
      }
    },
    computed: {
      uploadUrl() {
        return ''
      }
    },
    watch: {
      visible: {
        handler(newVal) {
          this.getTemplateDetail()
        },
        deep: true,
        immediate: false
      },
      improtData: {
        handler(newVal) {
          console.log(newVal, '=====')
        },
        deep: true,
        immediate: false
      }
    },
    methods: {
      async getTemplateDetail() {
        const { data, code } = await Http.get(this.templatUrl + this.templateCode)
        if (code === EnumApiCode.Success) {
          this.templateName = data?.templateName ?? ''
          this.fileUrl = data?.filePath ?? ''
          this.fileName = data?.fileName ?? ''
        }
      },
      // 上传前校检格式和大小
      handleBeforeUpload(file) {
        // 校检文件类型
        if (this.fileType) {
          let fileExtension = ''
          if (file.name.lastIndexOf('.') > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1)
          }
          const isTypeOk = this.fileType.includes(fileExtension.toLowerCase())
          if (!isTypeOk) {
            this.$message.warning(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`)
            return false
          }
        }
        // 校检文件大小
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 <= this.fileSize
          if (!isLt) {
            this.$message.warning(`上传文件大小不能超过 ${this.fileSize} MB!`)
            return false
          }
        }
        return true
      },
      onchange(f, list) {
        this.uploadFiles = list
      },
      // 文件个数超出
      handleExceed() {
        this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`)
      },
      // 上传成功回调
      handleUploadSuccess(res) {
        // clearInterval(this.processTimer)
        if (res.code !== 2000) {
          this.$modal.msgError(res.msg)
          this.uploadFiles.splice(0, 1)
          clearInterval(this.processTimer)
          this.loading = false
        } else {
          this.addSetInterval()
        }
      },
      // 上传失败
      handleUploadError() {
        this.loading = false
        this.uploadFlag = false
        // clearInterval(this.processTimer)
        this.$message.error('上传失败，请重试')
      },
      handleClose() {
        this.visible = false
      }
    }
  }
</script>
